import Phaser from 'phaser';

const BG_OUTER = 0x0a0f1f;
const BG_INNER = 0x2e1055;
const BOW = 0xf472b6;
const BOW_ACCENT = 0xfbcfe8;
const STRING = 0xfafafa;
const ARROW = 0xfde047;
const STROKE = 0xffffff;

export function drawPowerBow(g: Phaser.GameObjects.Graphics, size: number) {
  g.clear();
  const pad = Math.max(4, Math.floor(size * 0.08));
  const r = (size - pad * 2) / 2;
  const stroke = Math.max(3, Math.floor(size * 0.06));

  g.lineStyle(stroke, STROKE, 1);
  g.fillStyle(BG_OUTER, 1);
  g.fillCircle(0, 0, r);
  g.strokeCircle(0, 0, r);

  g.fillStyle(BG_INNER, 1);
  g.fillCircle(0, 0, r * 0.88);

  const bowR = r * 0.78;
  g.lineStyle(Math.max(4, r * 0.13), BOW, 1);
  g.beginPath();
  g.arc(-r * 0.15, 0, bowR, -Math.PI * 0.55, Math.PI * 0.55, false);
  g.strokePath();

  g.lineStyle(Math.max(2, r * 0.05), BOW_ACCENT, 1);
  g.beginPath();
  g.arc(-r * 0.15, 0, bowR * 0.92, -Math.PI * 0.5, Math.PI * 0.5, false);
  g.strokePath();

  const tipTop = { x: -r * 0.15 + bowR * Math.cos(-Math.PI * 0.55), y: bowR * Math.sin(-Math.PI * 0.55) };
  const tipBot = { x: -r * 0.15 + bowR * Math.cos(Math.PI * 0.55), y: bowR * Math.sin(Math.PI * 0.55) };
  const pullPoint = { x: -r * 0.15 + bowR * 0.3, y: 0 };

  g.lineStyle(Math.max(2, r * 0.04), STRING, 1);
  g.beginPath();
  g.moveTo(tipTop.x, tipTop.y);
  g.lineTo(pullPoint.x, pullPoint.y);
  g.lineTo(tipBot.x, tipBot.y);
  g.strokePath();

  const shaftLen = r * 1.05;
  const shaftY = 0;
  const shaftX1 = pullPoint.x;
  const shaftX2 = pullPoint.x + shaftLen;
  g.lineStyle(Math.max(3, r * 0.08), ARROW, 1);
  g.beginPath();
  g.moveTo(shaftX1, shaftY);
  g.lineTo(shaftX2, shaftY);
  g.strokePath();

  g.fillStyle(ARROW, 1);
  g.fillTriangle(
    shaftX2 + r * 0.15,
    shaftY,
    shaftX2 - r * 0.05,
    shaftY - r * 0.14,
    shaftX2 - r * 0.05,
    shaftY + r * 0.14,
  );
  g.lineStyle(1, 0x7c5a00, 1);
  g.strokePath();

  g.fillStyle(0xfbcfe8, 1);
  g.fillTriangle(
    shaftX1 - r * 0.12,
    shaftY - r * 0.08,
    shaftX1 + r * 0.05,
    shaftY,
    shaftX1 - r * 0.12,
    shaftY + r * 0.08,
  );
}
